// The SCT Summary guide (33_SctSummaryPage.jsx · ModuleHelp, Max 01/11).
const en = {
  searchT: 'Narrow the rows',
  searchB: 'Type to filter the table below. Column headers sort and filter too, and Clear appears once any filter is on.',
  seasonT: 'Pick the season',
  seasonB: 'The table shows one season at a time; the number beside each season is how many SAP codes it holds.',
  exportT: 'Export what you see',
  exportB: 'Downloads an Excel file of the rows on screen, so the search and filters you set are part of the export.',
  importT: 'Import a season workbook',
  importB: 'Reads the season\'s cycle-time workbook. A row that already exists is reported before anything is written and is never overwritten. Import format downloads the blank workbook.',
  tableT: 'The summary table',
  tableB: 'One row per SAP code per season, left to right as the calculation runs, with SCT last. The Action column at the right views or edits a row\'s measured values.',
};
const ko = {
  searchT: '행 좁히기',
  searchB: '입력하면 아래 표가 걸러집니다. 열 머리글로 정렬·필터도 가능하며, 필터가 켜져 있으면 초기화 버튼이 나타납니다.',
  seasonT: '시즌 선택',
  seasonB: '표에는 한 번에 한 시즌만 보입니다. 시즌 옆 숫자는 해당 시즌의 SAP 코드 수입니다.',
  exportT: '보이는 내용 내보내기',
  exportB: '화면에 보이는 행을 Excel 파일로 내려받습니다. 설정한 검색과 필터가 그대로 반영됩니다.',
  importT: '시즌 워크북 가져오기',
  importB: '시즌별 사이클 타임 워크북을 읽습니다. 이미 있는 행은 저장 전에 먼저 알려 주고, 덮어쓰지 않습니다. 가져오기 형식을 누르면 빈 워크북을 받을 수 있습니다.',
  tableT: '요약 표',
  tableB: '시즌별 SAP 코드당 한 행이며, 계산 순서대로 왼쪽에서 오른쪽으로 배치되고 SCT가 마지막입니다. 오른쪽 작업 열에서 측정값을 보거나 수정합니다.',
};
const vi = {
  searchT: 'Thu hẹp danh sách',
  searchB: 'Gõ để lọc bảng bên dưới. Tiêu đề cột cũng dùng để sắp xếp và lọc; khi đang có bộ lọc sẽ hiện nút Xóa lọc.',
  seasonT: 'Chọn season',
  seasonB: 'Bảng chỉ hiện một season mỗi lần; con số bên cạnh mỗi season là số mã SAP của season đó.',
  exportT: 'Xuất đúng những gì đang xem',
  exportB: 'Tải về file Excel gồm các dòng đang hiển thị, nên ô tìm kiếm và bộ lọc bạn đặt cũng áp dụng cho file xuất.',
  importT: 'Nhập file season',
  importB: 'Đọc file cycle time của season. Dòng nào đã có sẽ được báo trước khi ghi và không bao giờ bị ghi đè. Nút Mẫu nhập tải về file mẫu trống.',
  tableT: 'Bảng tổng hợp',
  tableB: 'Mỗi mã SAP mỗi season một dòng, xếp từ trái sang phải theo thứ tự tính toán, SCT ở cuối. Cột Thao tác bên phải để xem hoặc sửa các giá trị đã đo.',
};
const zh = {
  searchT: '缩小行范围',
  searchB: '输入文字即可筛选下方表格。列标题也可以排序和筛选，开启筛选后会出现 “清除”按钮。',
  seasonT: '选择季度',
  seasonB: '表格一次只显示一个季度，季度旁边的数字是该季度的 SAP 编码数量。',
  exportT: '导出当前所见',
  exportB: '把屏幕上显示的行下载为 Excel 文件，所以您设置的搜索和筛选也会体现在导出中。',
  importT: '导入季度工作簿',
  importB: '读取该季度的 cycle time 工作簿。已存在的行会在写入前先提示，并且绝不会被覆盖。“导入模板”可下载空白工作簿。',
  tableT: '汇总表',
  tableB: '每个季度的每个 SAP 编码一行，按计算顺序从左到右排列，SCT 在最后。右侧的“操作”列用于查看或修改实测值。',
};
const dictionary = { ns: 'tourSctSummary', en, ko, vi, zh };
export default dictionary;
